// File: src/MathPractice/TrigPracticeGraph.js
import React from "react";

function trigFnByName(fn) {
  if (fn === "sin") return Math.sin;
  if (fn === "cos") return Math.cos;
  if (fn === "tan") return Math.tan;
  return Math.sin;
}

/**
 * TrigPracticeGraph
 * @param { "sin" | "cos" | "tan" } mode
 * @param { number } highlightX (in radians, optional)
 * @param { number } width, height
 */
export default function TrigPracticeGraph({
  mode = "sin",
  highlightX = null,
  width = 220,
  height = 110,
}) {
  // X: -2π to 2π, Y: scale to show all (for tan, crop y)
  const xMin = -2 * Math.PI,
        xMax = 2 * Math.PI;
  const yMin = mode === "tan" ? -3 : -1.4, yMax = mode === "tan" ? 3 : 1.4;
  const samples = 200;
  const dx = (xMax - xMin) / samples;
  const fn = trigFnByName(mode);

  // Graph lines (SVG path)
  let pathD = "";
  let started = false;
  for (let i = 0; i <= samples; i++) {
    const x = xMin + i * dx;
    let y = fn(x);
    // for tan: crop wild spikes for pretty plot
    if (mode === "tan" && Math.abs(y) > 3) { started = false; continue; }
    const sx = ((x - xMin) / (xMax - xMin)) * width;
    const sy = height - ((y - yMin) / (yMax - yMin)) * height;
    if (!started) { pathD += `M${sx},${sy}`; started = true; }
    else pathD += `L${sx},${sy}`;
  }

  // Axes (centered)
  const xAxisY = ((0 - yMin) / (yMax - yMin)) * height;
  const yAxisX = ((0 - xMin) / (xMax - xMin)) * width;

  // Highlight point (dot)
  let highlightDot = null;
  if (typeof highlightX === "number") {
    let y = fn(highlightX);
    if (mode === "tan" && Math.abs(y) > 3) y = null;
    if (y !== null && y !== undefined && isFinite(y)) {
      const sx = ((highlightX - xMin) / (xMax - xMin)) * width;
      const sy = height - ((y - yMin) / (yMax - yMin)) * height;
      highlightDot = <circle cx={sx} cy={sy} r={5} fill="#d32f2f" stroke="#222" strokeWidth={1.2} />;
    }
  }

  return (
    <svg width={width} height={height} style={{ background: "#fff", border: "1px solid #bbb", borderRadius: 8 }}>
      {/* Axes */}
      <line x1={0} y1={xAxisY} x2={width} y2={xAxisY} stroke="#bbb" strokeWidth={1} />
      <line x1={yAxisX} y1={0} x2={yAxisX} y2={height} stroke="#bbb" strokeWidth={1} />
      {/* Graph */}
      <path d={pathD} fill="none" stroke={
        mode === "sin" ? "#1976d2" : mode === "cos" ? "#388e3c" : "#fbc02d"
      } strokeWidth={2} />
      {/* Highlight dot */}
      {highlightDot}
    </svg>
  );
}
